"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductCard_1 = require("./ProductCard");
exports.default = ProductCard_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ProductCard/index.js
// module id = 1212
// module chunks = 8